import { getDateNow } from 'odfjell-date-time-utils/dateTimeUtils';
import useAppFeature from './useAppFeature';
import { AppFeatureEnum } from 'src/enums/appFeatureEnum';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';

export default () => {
    const { isFeatureEnabled } = useAppFeature();

    const checkLoadedStowageIntegration = (imoNumber: number, loadedMasterStowagePlan: StowagePlan): boolean =>
        isFeatureEnabled({ featureEnum: AppFeatureEnum.StowageIntegration, imoNumber, date: getDateNow() }) && !loadedMasterStowagePlan;

    return {
        checkLoadedStowageIntegration,
    };
};
